import { render, staticRenderFns } from "./roleTreeDialog.vue?vue&type=template&id=7aa878f7&scoped=true"
import script from "./roleTreeDialog.vue?vue&type=script&lang=js"
export * from "./roleTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./roleTreeDialog.vue?vue&type=style&index=0&id=7aa878f7&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa878f7",
  null
  
)

export default component.exports